/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductTimeseriesDto } from '../models/product-timeseries-dto';
import { ProductTimeseriesRequestDto } from '../models/product-timeseries-request-dto';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findProductTimeseries
   */
  static readonly FindProductTimeseriesPath = '/product-timeseries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findProductTimeseries()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findProductTimeseries$Response(params?: {
    body?: ProductTimeseriesRequestDto
  }): Observable<StrictHttpResponse<Array<ProductTimeseriesDto>>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.FindProductTimeseriesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProductTimeseriesDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findProductTimeseries$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findProductTimeseries(params?: {
    body?: ProductTimeseriesRequestDto
  }): Observable<Array<ProductTimeseriesDto>> {

    return this.findProductTimeseries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProductTimeseriesDto>>) => r.body as Array<ProductTimeseriesDto>)
    );
  }

}
